module.exports = __webpack_public_path__ + "static/media/bin.a0d0dc77.svg";